import { render, staticRenderFns } from "./TransactionUpdate.vue?vue&type=template&id=3dda4fd5"
import script from "./TransactionUpdate.vue?vue&type=script&lang=js"
export * from "./TransactionUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports